import React from 'react';
import './About.css';
import EssenceCard from '../../components/EssenceCard/EssenceCard.jsx';

const About = () => {
  const soulEssences = [
    {
      id: 1,
      name: "Sjelsessens 1",
      location: "Der halsen og haken møtes",
      gives: "Relasjon til Universets Essens",
      path: "/essence/1"
    },
    {
      id: 2,
      name: "Sjelsessens 2",
      location: "Solar Plexus",
      gives: "Relasjon til Sjelens Dans",
      path: "/essence/2"
    },
    {
      id: 3,
      name: "Sjelsessens 3",
      location: "Øverst på brystbenet",
      gives: "Relasjon til Sjelens Lysstråler",
      path: "/essence/3"
    },
    {
      id: 4,
      name: "Sjelsessens 4",
      location: "10 cm under navlen",
      gives: "Relasjon til Sjelens Dyp",
      path: "/essence/4"
    },
    {
      id: 5,
      name: "Sjelsessens 5",
      location: "Toppen av hodet, fontanellen",
      gives: "Relasjon til kosmisk helhet",
      path: "/essence/5"
    },
    {
      id: 6,
      name: "Sjelsessens 6",
      location: "Midt på brystbenet",
      gives: "Relasjon til Hjertets Vibrasjoner",
      path: "/essence/6"
    },
    {
      id: 7,
      name: "Sjelsessens 7",
      location: "Pannen, det tredje øyet",
      gives: "Relasjon til Kreativ Stillhet",
      path: "/essence/7"
    },
    {
      id: 8,
      name: "Sjelsessens 8",
      location: "Nederst på ryggen, Sacrum",
      gives: "Relasjon til Manifestert Tilstedeværelse",
      path: "/essence/8"
    },
    {
      id: 9,
      name: "Sjelsessens 9",
      location: "Mellom skulderbladene",
      gives: "Relasjon til Universets Puls",
      path: "/essence/9"
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-content">
          <h1 className="hero-title">De Ni Sjelsessensene</h1>
          <p className="hero-subtitle">Portaler mellom din indre visdom og det større energetiske feltet</p>
          <div className="hero-decoration">
            <div className="light-beam"></div>
            <div className="light-beam"></div>
            <div className="light-beam"></div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="container">
          <div className="intro-section">
            <h2 className="section-title">Kort om hver av Sjelsessensene</h2>
            <p className="intro-text">
              I lysvevingen arbeider vi med ni ulike Sjelsessenspunkter, som hver bærer en spesiell vibrasjon i kroppens struktur. 
              Disse essensene er portaler mellom vår indre visdom og det større energetiske feltet vi alle er en del av.
            </p>
          </div>

          <div className="essences-grid">
            {soulEssences.map((essence) => (
              <EssenceCard
                key={essence.id}
                id={essence.id}
                name={essence.name}
                location={essence.location}
                gives={essence.gives}
                path={essence.path}
              />
            ))}
          </div>

          <div className="closing-section">
            <div className="closing-box">
              <p>
                Hver Sjelsessens er en unik portal til din sjel og til det universelle feltet. 
                Gjennom lysveving kan du åpne og balansere disse forbindelsene, 
                slik at din sjel får uttrykke seg gjennom deg i hverdagen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Elements */}
      <div className="floating-elements">
        <div className="floating-light"></div>
        <div className="floating-light"></div>
        <div className="floating-light"></div>
      </div>
    </div>
  );
};

export default About;
